import { defineStore } from 'pinia';
import type { NavigationNode } from '../../types/link';
import { ref, watch } from 'vue';
import { useStoreAllNavs } from './allNavs';

export type StoreMetaNav = {
  items: NavigationNode[];
};

const storeId = 'store-meta-nav';

export const useStoreMetaNavigation = defineStore(storeId, () => {
  const storeAllNavs = useStoreAllNavs();
  const items = ref<StoreMetaNav['items']>();

  async function fetchItems() {
    if (!storeAllNavs.allNavs?.metaNav) {
      console.error(`${storeId} >>> error`, 'allNavsStore is not available');
      return;
    }

    const navItems = new Array(storeAllNavs.allNavs.metaNav);

    if (navItems) {
      items.value = navItems;
    }
  }

  watch(storeAllNavs, () => {
    if (storeAllNavs.allNavs && !items.value) {
      fetchItems();
    }
  });

  return {
    items,
  };
});
